type BynIconProps = {
    className?: string;
    title?: string;
};

/** Official NBRB Belarusian ruble glyph (nbrb font). */
export function BynIcon({ className, title = "белорусский рубль" }: BynIconProps) {
    return (
        <i
            className={["nbrb-icon", "nbrb-icon-byn", className].filter(Boolean).join(" ")}
            role="img"
            aria-label={title}
            title={title}
        />
    );
}

type BynAmountProps = {
    amount: number;
    period?: string;
    className?: string;
    amountClassName?: string;
};

/** e.g. `39 [BYN glyph] / мес` with official NBRB symbol. */
export function BynAmount({ amount, period, className, amountClassName }: BynAmountProps) {
    const formatted = new Intl.NumberFormat("ru-BY", { maximumFractionDigits: 0 }).format(amount);

    return (
        <span className={className}>
            <span className={amountClassName}>{formatted}</span>
            {"\u00A0"}
            <BynIcon />
            {period ? (
                <>
                    {"\u00A0"}/ {period}
                </>
            ) : null}
        </span>
    );
}
